import './index.css'

const TabItem = props => {
  const {items, onSelects, isActive} = props
  const {tabId, displayText} = items

  const isActiveClassName = isActive ? 'active' : ''
  const onClickButton = () => {
    onSelects(tabId)
  }

  return (
    <li>
      <button
        type="button"
        onClick={onClickButton}
        className={`tabCard ${isActiveClassName}`}
      >
        {displayText}
      </button>
    </li>
  )
}
export default TabItem
